import { Box, Button, Tab, TableRow } from '@mui/material';
import { styled } from '@mui/material';

export const admin = {
  ContentContainer: styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.common.white,
    borderRadius: '16px',
    padding: '0px 8px',
  })),
  InfoTab: styled(Tab)(({ theme }) => ({
    '&:not(.Mui-selected)': { color: theme.palette.grey[600] },
    '&.Mui-selected': { color: theme.palette.info.main },
  })),
  TopContainer: styled(Box)(() => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 16px',
  })),
  ActionContainer: styled(Box)(() => ({
    display: 'flex',
    gap: '12px',
  })),
  IconButton: styled(Button)(() => ({
    display: 'flex',
    gap: '8px',
  })),
};

export const StyledHoverTableRow = styled(TableRow)(({ theme }) => ({
  '&.MuiTableRow-hover:hover': { backgroundColor: theme.palette.info.lighter },
}));
